module.exports = __webpack_public_path__ + "img/7_67.d1f9de27.png";